export class AuthErrors {
   public static NotAuthorizedException = 'NotAuthorizedException';
   public static UserAlreadyAuthenticatedException = 'UserAlreadyAuthenticatedException';
   public static UserLambdaValidationException = 'UserLambdaValidationException';
   public static UserNotFoundException = 'UserNotFoundException';
   public static UserUnAuthenticatedException = 'UserUnAuthenticatedException';
   public static UserNotFoundExceptionMsg = 'usernotfoundexception: usermigration failed with error email_required.';
   public static ValidationDataVerified = 'cannot reset password for the user but validation data verified';
}